import { css, keyframes } from '@emotion/react';
import { useMemo } from 'react';

import { useTheme } from '@bai/utils/theme';

export const spinnerMargins = {
  all: '100px auto',
  none: '15px auto',
  exportButton: '0px 33px',
  dashboardLaunchButton: '0px 15px',
};

export interface SpinnerProps {
  height?: string;
  width?: string;
  margin?: string;
  color?: string;
  [key: string]: any; // Allow other arbitrary props
}

const stretchDelay = keyframes`
  from, 0%, 40%, 100%, to {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1.0);
  }
`;

export function Spinner({
  height = '40px',
  width = '50px',
  margin = spinnerMargins.all,
  color,
  ...otherProps
}: SpinnerProps) {
  const theme = useTheme();

  const bars = useMemo(
    () =>
      new Array(5).fill(0).map((el, i) => (
        <div
          key={i}
          css={css`
            background-color: ${color || theme?.branding?.primaryColor};
            height: 100%;
            width: 6px;
            margin: 0 2px;
            display: inline-block;
            animation: ${stretchDelay} 1.2s infinite ease-in-out;
            animation-delay: ${-1.2 + i / 10}s;
          `}
        />
      )),
    [color, theme?.branding?.primaryColor],
  );

  return (
    <div
      css={css`
        margin: ${margin};
        width: ${width};
        height: ${height};
        text-align: center;
        font-size: 10px;
        z-index: 20;
      `}
      data-testid="spinner"
      {...otherProps}
    >
      {bars}
    </div>
  );
}

export default Spinner;
